import React, { useEffect, useState } from 'react';
import Navbar from './Navbar';
import { useLocation } from 'react-router-dom';
import { navGroupForPath } from './navTree';

const NavbarContainer = ({ onCollapseMenu = () => {}, visibleSideMenu, isSmallScreen, mobileCollapse, isPortraitMode }) => {
    const location = useLocation();
    const defaultMenu = 'dashboard';
    const selectedKeyArr = location?.pathname?.split('/') ?? [];
    const selectedPath = location?.pathname.slice(location?.pathname.indexOf('/') + 1) || defaultMenu;
    let selectedKey = selectedKeyArr?.length > 2 ? selectedPath : selectedKeyArr?.[1] || defaultMenu;
    const initialInterval = 10;

    // Not simply selectedKeyArr[1]: the Monitor group's key is
    // 'live_historical_data' while two of its pages use a 'live_data' prefix,
    // so the raw first segment left that group collapsed on a deep link.
    const mainMenu = navGroupForPath(location?.pathname ?? '', defaultMenu);
    const [openKeys, setOpenKeys] = useState([mainMenu]);

    const onSideMenuVisiblityChange = (openMenuKeys, interval) => {
        setTimeout(() => {
            setOpenKeys(openMenuKeys);
        }, interval);
    };

    useEffect(() => {
        if (!visibleSideMenu && !mobileCollapse) {
            onSideMenuVisiblityChange([mainMenu], initialInterval);
        } else {
            onSideMenuVisiblityChange([], initialInterval + 1);
        }
    }, [visibleSideMenu, mobileCollapse]);

    const closeMenu = () => {
        setOpenKeys([]);
    };
    
    const onExpandMenu = (keys) => {
        if (keys?.length > 0) {
            setOpenKeys([keys?.[keys?.length - 1]]);
        } else {
            closeMenu();
        }
    };

    return (
        <Navbar
            onExpandMenu={onExpandMenu}
            openKeys={openKeys}
            visibleSideMenu={visibleSideMenu}
            mobileCollapse={mobileCollapse}
            isSmallScreen={isSmallScreen}
            isPortraitMode={isPortraitMode}
            onCollapseMenu={onCollapseMenu}
            selectedKey={selectedKey}
            closeMenu={closeMenu}
        />
    );
};

export default NavbarContainer;
